import { PageListCachedDataSource } from './BaseDataSources';
import { ISeller } from '../Interfaces';

export class ExitDealBuyerSource extends PageListCachedDataSource<ISeller> {
  public constructor(isActive?: boolean) {
    super('/datasource/exitdealbuyers', { isActive });
  }
}
